export default function isCheckboxItem(element) {
  const role = element.getAttribute('role');
  return role === 'radio' || role === 'menuitemradio';
}